import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConnectionOverlayService {
  isShown = false;
  showContinue = false;
  showExit = false;

  constructor() {
    (window as any).overlay = this;
  }

  show(doContinue: boolean, doExit: boolean): void {
    this.isShown = true;
    this.showContinue = doContinue;
    this.showExit = doExit;
  }

  hide(): void {
    this.isShown = false;
    this.showContinue = false;
    this.showExit = false;
  }
}
